import { SearchMeta } from './types';
import { Account } from './objects/Account';
import { Subscription } from './objects/Subscription';
import { Invoice } from './objects/Invoice';
import { Payment } from './objects/Payment';
import { Order } from './objects/Order';
import { CreditMemo } from './objects/CreditMemo';
import { Navigation } from './objects/Navigation';
import { DebitMemo } from './objects/DebitMemo';
import { ProductCatalog } from './objects/ProductCatalog';
import { InvoiceSchedule } from './objects/InvoiceSchedule';
import { BillRun } from './objects/BillRun';

export const searchMetadata: ReadonlyArray<SearchMeta> = Object.freeze([
  Account,
  Subscription,
  Invoice,
  CreditMemo,
  DebitMemo,
  BillRun,
  Payment,
  Order,
  InvoiceSchedule,
  ProductCatalog,
  Navigation,
]);
